import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 214668FF-C50D-4D69-B916-AE66E73CB3B0
 * name fridge-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fridge-outline.svg
 * tags
 * - Home Automation 
 */
export const FridgeOutlineIcon = createSvgIcon(<><path d="M9,21V22H7V21A2,2 0 0,1 5,19V4A2,2 0 0,1 7,2H17A2,2 0 0,1 19,4V19A2,2 0 0,1 17,21V22H15V21H9M7,4V9H17V4H7M7,19H17V11H7V19M8,12H10V15H8V12M8,6H10V8H8V6Z" /></>, 'FridgeOutlineIcon');
export default FridgeOutlineIcon